import { Link } from "react-router-dom";

const H2 = ({ children }) => <h2 className="font-display text-2xl font-bold text-slate-900 mt-8 mb-3">{children}</h2>;
const P = ({ children }) => <p className="text-slate-700 leading-relaxed my-3">{children}</p>;

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
      <Link to="/" className="text-emerald-800 text-sm font-semibold" data-testid="privacy-back">← Back to Blurblive</Link>
      <h1 className="font-display text-4xl font-extrabold text-slate-900 mt-4">Privacy Policy</h1>
      <p className="text-xs text-slate-500 mt-1">Blurblive Markdowns · Effective 1 December 2026</p>

      <P>This policy explains how Blurblive Markdowns collects and uses personal information under the New Zealand Privacy Act 2020.</P>

      <H2>1. Who we are</H2>
      <P>Blurblive.nz (Waikato, New Zealand) — the &ldquo;agency&rdquo; for the purposes of the Privacy Act 2020. Contact: <a className="text-emerald-800 underline underline-offset-4" href="mailto:franciscusvanhelmond@gmail.com">franciscusvanhelmond@gmail.com</a>.</P>

      <H2>2. Information we collect</H2>
      <P><strong>Stores:</strong> email, password (hashed with bcrypt — we never see the plain-text), store name, region, phone and address (if provided), payment metadata via Stripe (we do not store card numbers), photos and product details you upload.</P>
      <P><strong>Shoppers:</strong> email if you follow a store or region. Optional coarse location (region-level) if you allow the browser prompt on first visit. Basic browser and device info from server logs.</P>
      <P><strong>Google sign-in:</strong> if you use it, we receive your email, name, and profile picture from Google.</P>

      <H2>3. Why we collect it</H2>
      <P>To run the platform: display listings publicly (Stores), send follow/reminder emails (Shoppers), process $2/$5 payments (via Stripe), keep the site secure, and improve the service. We use browser geolocation only to auto-filter the deals feed to your region — it is not stored on our servers.</P>

      <H2>4. Who we share it with</H2>
      <P>We share personal information only with third-party service providers strictly needed to run the platform:</P>
      <ul className="list-disc pl-6 text-slate-700 space-y-1">
        <li><strong>Stripe</strong> — for payment processing (US/EU-hosted).</li>
        <li><strong>Resend</strong> — to deliver transactional emails.</li>
        <li><strong>Emergent</strong> — hosting, object storage for images.</li>
        <li><strong>Google</strong> — only if you sign in with Google.</li>
      </ul>
      <P>We do not sell your data. We never share your email with other Stores or Shoppers.</P>

      <H2>5. Where it&apos;s stored</H2>
      <P>Data is stored in MongoDB via the Emergent platform. Some processors (Stripe, Resend, Google) hold data outside New Zealand. By using Blurblive you consent to that transfer.</P>

      <H2>6. How long we keep it</H2>
      <P>Store accounts and listings are kept while the account is active. Follower emails are kept until you unsubscribe. Payment records are kept for 7 years to comply with NZ tax law. You can request deletion at any time via the contact email.</P>

      <H2>7. Your rights</H2>
      <P>Under the Privacy Act 2020 you may request access to, correction of, or deletion of your personal information. Email us and we will respond within 20 working days.</P>

      <H2>8. Cookies &amp; local storage</H2>
      <P>We use a session cookie for login and a small amount of browser <em>localStorage</em> to remember your region choice and how many deals you&apos;ve found. We do not use third-party advertising cookies or trackers.</P>

      <H2>9. Complaints</H2>
      <P>If you&apos;re not satisfied with how we handle your information, you can complain to the NZ Office of the Privacy Commissioner: <a className="text-emerald-800 underline underline-offset-4" href="https://www.privacy.org.nz" target="_blank" rel="noreferrer">privacy.org.nz</a>.</P>

      <H2>10. Updates</H2>
      <P>We may update this policy from time to time. Material changes will be emailed to Stores.</P>

      <p className="text-xs text-slate-500 mt-10">This is a plain-English starting point for a small NZ platform and is not legal advice. For a commercial launch a NZ-qualified lawyer should review it.</p>
    </div>
  );
}
